import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntAnnouncementscon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 3.5H1.5V8.5H1.7H3.5V3.5ZM0 3V8.5V9C0 9.47954 0.337539 9.88024 0.78799 9.97748L0.8 10L3.71765 15.4706C3.89144 15.7965 4.23069 16 4.6 16H6.33333C7.08825 16 7.57094 15.1955 7.21569 14.5294L4.90756 10.2017L11.5 11.6667L13 12V10.4634V1.53659V0L11.5 0.333333L4 2H1C0.447715 2 0 2.44772 0 3ZM4.9 14.5L2.5 10H3.1L5.5 14.5H4.9ZM5 8.68563L11.5 10.1301V1.86992L5 3.31437V8.68563ZM16 6C16 6.91851 15.3808 7.6924 14.5371 7.92706V4.07294C15.3808 4.30759 16 5.08149 16 6Z"
      />
    </SntIcon>
  );
};

export default SntAnnouncementscon;
